import React from "react";

const MaintenanceMode = () => {
  return (
    <div className="container">
      <p>Maintenance mode</p>
    </div>
  );
};

export default MaintenanceMode;